module.exports = __webpack_public_path__ + "img/pendingIcon.b622812f.svg";